/* eslint-disable @typescript-eslint/indent */
/* eslint-disable operator-linebreak */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/jsx-props-no-spreading */
import { useState } from 'react';
import { useField } from 'formik';
import {
  FormControl,
  OutlinedInput,
  InputLabel,
  FormHelperText,
  InputAdornment,
  IconButton,
  Grid,
} from '@mui/material';
import {
  Visibility,
  VisibilityOff,
  Verified,
  Error,
} from '@mui/icons-material';

interface InputProps {
  type: 'text' | 'password';
  name: string;
  label: string;
  size: number;
}

const Input: React.FC<InputProps> = ({ size, ...props }) => {
  const [field, meta] = useField(props);
  const [toggleShowPassword, setToggleShowPassword] = useState<boolean>(false);

  const handleToggleShowPassword = () => {
    setToggleShowPassword((togglePassword) => !togglePassword);
  };

  const isError = Boolean(meta.error && meta.touched);
  const isValid = Boolean(!meta.error && field.value);

  const PasswordIcon = props.type === 'password' && (
    <IconButton
      aria-label="toggle password visibility"
      onClick={handleToggleShowPassword}
      edge="end"
    >
      {toggleShowPassword ? (
        <Visibility fontSize="small" />
      ) : (
        <VisibilityOff fontSize="small" />
      )}
    </IconButton>
  );

  const TextIcon = (isError || isValid) && props.type !== 'password' && (
    <IconButton aria-label="verify check" edge="end">
      {isError ? (
        <Error color="error" fontSize="small" />
      ) : (
        <Verified color="success" fontSize="small" />
      )}
    </IconButton>
  );

  const InputType =
    props.type !== 'password'
      ? props.type
      : toggleShowPassword
      ? 'text'
      : 'password';

  return (
    <Grid item xs={size}>
      <FormControl
        sx={{ width: '100%' }}
        variant="outlined"
        error={isError}
        color={isValid ? 'success' : 'primary'}
      >
        <InputLabel htmlFor={`outlined-adornment-${props.name}`}>
          {props.label}
        </InputLabel>
        <OutlinedInput
          name={props.name}
          label={props.label}
          type={InputType}
          onBlur={field.onBlur}
          onChange={field.onChange}
          value={field.value}
          endAdornment={
            <InputAdornment position="end">
              {PasswordIcon}
              {TextIcon}
            </InputAdornment>
          }
        />
        {isError && <FormHelperText>{meta.error}</FormHelperText>}
      </FormControl>
    </Grid>
  );
};

export default Input;
